import { Target } from "@vytant/stimulus-decorators";
import { autofocus, hide } from "../helpers/dom";
import ApplicationController from "./application_controller";

export default class ModalController extends ApplicationController {
  @Target dialogTarget!: HTMLDialogElement;
  @Target containerTarget!: HTMLElement;
  @Target spinnerTarget!: HTMLElement;
  @Target contentTarget!: HTMLElement;

  loading(event: StimulusEvent) {
    event.preventDefault();
    // hide instead of replacing contents to avoid elements with multiple event listeners removing itself
    // e.g. an element inside the modal with 'modal#loading xhr#fetch' actions would remove itself before xhr#fetch fires
    hide(this.containerTarget.children);
    this.containerTarget.insertAdjacentHTML("afterbegin", this.spinnerTarget.innerHTML);
    this.show();
  }

  show() {
    this.dialogTarget.showModal();
    // set overflow-hidden to avoid scrollable background content
    document.body.classList.add("overflow-hidden");
  }

  insert(event: StimulusEvent) {
    this.containerTarget.innerHTML = event.detail.html;
    autofocus(this.containerTarget);
  }

  hide() {
    this.dialogTarget.close();
    // remove overflow-hidden added above in show()
    document.body.classList.remove("overflow-hidden");
  }

  backdropClose(event: StimulusEvent) {
    if (!this.dialogTarget.open) return;

    if (!event.composedPath().includes(this.contentTarget)) {
      this.hide();
    }
  }
}
